export const slides = [
  {
    id: 0,
    type: "hero",
    tag: "NEUGODNA ISTINA",
    title: "Vaš Novac Se\nUništava",
    subtitle:
      "Svaki dolar koji uštedite gubi vrijednost dok spavate. To nije slučajnost — to je dizajnirano. Razumijte sustav koji radi protiv vas i otkrijte jedinu imovinu stvorenu da to popravi.",
    cta: "Započni Putovanje",
  },
  {
    id: 1,
    type: "statement",
    tag: "POGLAVLJE 01 — TEMELJ",
    title: "Nekada Davno,\nNovac Je Nešto\nZnačio",
    body: "Tisućama godina zlato je služilo kao okosnica globalnog monetarnog sustava. Svaki dolar u optjecaju bio je pokriven fizičkom količinom zlata u rezervama. To nije bila samo tradicija — to je bilo ograničenje moći.",
    highlight:
      "Vlade nisu mogle tiskati novac iznad onoga što su zlatne rezerve dopuštale. To jedno pravilo održavalo je gospodarstva poštenim tisućljećima.",
    factLabel: "GODINA ZLATNOG STANDARDA",
    factValue: "5,000+",
    factNote: "Zlato se koristi kao novac od 3.000 godina pr. Kr.",
  },
  {
    id: 2,
    type: "event",
    tag: "POGLAVLJE 02 — PRIJELOMNA TOČKA",
    title: "15. Kolovoza 1971.",
    subtitle: "Dan Kada Je Novac Umro",
    body: "Predsjednik Richard Nixon prekinuo je vezu između američkog dolara i zlata. Ono što je najavljeno kao \"privremena mjera\" postalo je trajno. Po prvi put u povijesti, svaka velika valuta na Zemlji bila je pokrivena samo povjerenjem u vlade.",
    stats: [
      { value: "97%", label: "Kupovna moć dolara izgubljena od 1971." },
      { value: "3,400%", label: "Povećanje američkog nacionalnog duga od 1971." },
      { value: "$0", label: "Zlata koje danas pokriva američki dolar" },
    ],
  },
  {
    id: 3,
    type: "breakdown",
    tag: "POGLAVLJE 03 — SKRIVENI POREZ",
    title: "Inflacija Nije\nPrirodna",
    body: "Govore vam da je inflacija normalan dio zdrave ekonomije. To je laž. Inflacija je izravna posljedica povećanja novčane mase. Kada središnje banke tiskaju bilijune, svaki postojeći dolar vrijedi manje. Vaša štednja nestaje — tiho.",
    comparisons: [
      { year: "1971", item: "Prosječna Kuća", price: "$25,200" },
      { year: "2024", item: "Prosječna Kuća", price: "$420,800" },
      { year: "1971", item: "Galona Benzina", price: "$0.36" },
      { year: "2024", item: "Galona Benzina", price: "$3.80" },
      { year: "1971", item: "Školarina (god.)", price: "$1,410" },
      { year: "2024", item: "Školarina (god.)", price: "$42,162" },
    ],
    quote: '"Inflacija je oporezivanje bez zakonodavstva." — Milton Friedman',
  },
  {
    id: 4,
    type: "mechanism",
    tag: "POGLAVLJE 04 — STROJ DUGA",
    title: "Svaki Dolar Je\nPosuđen Za\nPostojanje",
    body: "Novac se ne stvara iz vrijednosti ili produktivnosti. Stvara se iz duga. Kada banka izda kredit, ona ne posuđuje novac koji ima — stvara novi novac iz ničega. To se zove bankarstvo s djelomičnim rezervama.",
    steps: [
      { number: "01", title: "Položite 1.000 $", description: "Vaš novac ide na bankovni račun. Mislite da je siguran." },
      { number: "02", title: "Banka zadrži 100 $, posudi 900 $", description: "Banka je dužna držati samo 10% u rezervi. Ostatak se posuđuje." },
      { number: "03", title: "Tih 900 $ se ponovno položi", description: "Zajmoprimac potroši 900 $. Oni ulaze na drugi bankovni račun." },
      { number: "04", title: "Ciklus se ponavlja beskonačno", description: "Vaših originalnih 1.000 $ može stvoriti do 10.000 $ u sustavu. Ništa od toga nije stvarno." },
    ],
    bottomFact: "Ukupni globalni dug prelazi 307 bilijuna dolara. Postoji samo 40 bilijuna dolara u stvarnoj valuti.",
  },
  {
    id: 5,
    type: "power",
    tag: "POGLAVLJE 05 — ZLOUPORABA",
    title: "Oni Koji Tiskaju\nNovac Stvaraju\nPravila",
    body: "Središnje banke i vlade mogu stvarati neograničene količine novca bez odgovornosti prema ljudima. Ta moć korištena je za financiranje ratova, spašavanje korporacija i obogaćivanje već bogatih — dok prosječna osoba plaća cijenu kroz inflaciju.",
    abuses: [
      { event: "Spašavanje banaka 2008.", amount: "700+ mlrd $", detail: "Banke su kockale s vašim novcem, izgubile i spašene su vašim novcem." },
      { event: "Tiskanje novca 2020.", amount: "13+ bil $", detail: "40% svih američkih dolara ikad stvorenih ispisano je u jednoj godini." },
      { event: "Cantillonov Efekt", amount: "Neprestano", detail: "Oni koji su najbliži tiskari novca profitiraju prvi. Vi dobijete inflaciju." },
    ],
  },
  {
    id: 6,
    type: "wealthgap",
    tag: "POGLAVLJE 06 — REZULTAT",
    title: "Rastući Jaz\nu Bogatstvu",
    body: "Otkako je napušten zlatni standard, jaz između bogatih i svih ostalih eksplodirao je. To nije slučajnost — to je izravna posljedica monetarnog sustava koji nagrađuje one najbliže tiskari novca.",
    metrics: [
      { label: "Najbogatijih 1% Posjeduje Više Od", value: "Donjih 50%", detail: "Zajedno. Najbogatiji 1% drži više bogatstva od polovice planeta." },
      { label: "Omjer Plaća CEO-Radnik", before: "20:1", beforeYear: "1965", after: "399:1", afterYear: "2024" },
      { label: "Realne Plaće Od 1971.", value: "Stagnirale", detail: "Produktivnost je porasla 64,6% od 1979. Satnice su porasle samo 17,3%. Ostatak je otišao na vrh." },
    ],
    bottomFact: "Sustav nije pokvaren. Radi točno onako kako je dizajniran — samo ne za vas.",
  },
  {
    id: 7,
    type: "solution",
    tag: "POGLAVLJE 07 — ODGOVOR",
    title: "Uđite Bitcoin",
    subtitle: "Novac Naroda",
    body: "Godine 2009., anonimni tvorac poznat kao Satoshi Nakamoto objavio je Bitcoin — peer-to-peer elektronički sustav gotovine koji ne zahtijeva banke, vlade ni povjerenje. Po prvi put u ljudskoj povijesti, novac kontrolira matematika, a ne ljudi.",
    principles: [
      "Nijedna središnja vlast ga ne može kontrolirati",
      "Nitko ne može tiskati više",
      "Nitko ga ne može konfiscirati",
      "Nitko ne može cenzurirati transakcije",
      "Bilo tko, bilo gdje ga može koristiti",
    ],
  },
  {
    id: 8,
    type: "halving",
    tag: "POGLAVLJE 08 — MOTOR OSKUDICE",
    title: "Prepolovljenje",
    subtitle: "Programirana Oskudica",
    body: "Svakih 210.000 blokova (otprilike svake 4 godine), nagrada za rudarenje novog Bitcoina prepolovi se. To znači da se stopa novog Bitcoina koji ulazi u sustav smanjuje s vremenom — potpuna suprotnost fiat valuti. Do 2140. svih 21 milijun Bitcoina bit će iskopano.",
    halvings: [
      { year: "2009", reward: "50 BTC", event: "Blok Geneze", priceAtTime: "$0" },
      { year: "2012", reward: "25 BTC", event: "1. Prepolovljenje", priceAtTime: "$12" },
      { year: "2016", reward: "12.5 BTC", event: "2. Prepolovljenje", priceAtTime: "$650" },
      { year: "2020", reward: "6.25 BTC", event: "3. Prepolovljenje", priceAtTime: "$8,700" },
      { year: "2024", reward: "3.125 BTC", event: "4. Prepolovljenje", priceAtTime: "$64,000" },
      { year: "2028", reward: "1.5625 BTC", event: "5. Prepolovljenje", priceAtTime: "?" },
    ],
    insight: "Nakon svakog prepolovljenja u povijesti, cijena Bitcoina dosegla je novi rekord unutar 12-18 mjeseci. Ponuda pada. Potražnja raste. Matematika radi ostatak.",
  },
  {
    id: 9,
    type: "properties",
    tag: "POGLAVLJE 09 — SVOJSTVA",
    title: "Što Čini Bitcoin\nNajtvrđim Novcem\nIkad Stvorenim",
    properties: [
      { name: "Rijedak", value: "21 Milijun", description: "Nikada neće postojati više od 21 milijun Bitcoina. Više se nikada ne može stvoriti. To provodi kod, a ne obećanja.", icon: "diamond" },
      { name: "Decentraliziran", value: "19,000+ Čvorova", description: "Nijedan entitet ne kontrolira Bitcoin. Pokreću ga tisuće neovisnih računala diljem svijeta.", icon: "network" },
      { name: "Nepromjenjiv", value: "850,000+ Blokova", description: "Svaka transakcija ikad napravljena trajno je zabilježena. Nijedna vlada ni korporacija ne može mijenjati knjigu.", icon: "shield" },
      { name: "Prenosiv", value: "Bez Granica", description: "Pošaljite bilo koji iznos vrijednosti bilo gdje u svijetu u minutama. Bez banaka, bez granica, bez dozvole.", icon: "globe" },
      { name: "Djeljiv", value: "100M Satoshija", description: "Svaki Bitcoin može se podijeliti na 100 milijuna jedinica zvanih satoshi. Svatko može posjedovati Bitcoin, čak i s 1 $.", icon: "layers" },
      { name: "Provjerljiv", value: "Otvoreni Kod", description: "Svatko može pregledati Bitcoin kod i provjeriti cjelokupnu monetarnu ponudu u bilo kojem trenutku.", icon: "check" },
    ],
  },
  {
    id: 10,
    type: "trackrecord",
    tag: "POGLAVLJE 10 — REZULTATI",
    title: "Brojke Govore\nSame Za Sebe",
    subtitle: "Najbolja Imovina Posljednjih 15 Godina",
    milestones: [
      { year: "2010", price: "$0.003", event: "Prva zabilježena cijena" },
      { year: "2013", price: "$1,000", event: "Prvo veliko tržišno kretanje" },
      { year: "2017", price: "$19,800", event: "Masovna svijest" },
      { year: "2021", price: "$69,000", event: "Institucionalno usvajanje" },
      { year: "2024", price: "$100,000+", event: "Početak usvajanja od strane država" },
    ],
    adoptionStats: [
      { value: "500M+", label: "Ljudi globalno posjeduje kripto" },
      { value: "46%", label: "Fortune 100 tvrtki gradi na blockchainu" },
      { value: "130+", label: "Država istražuje ili pokreće CBDC-ove" },
      { value: "15+", label: "Bitcoin spot ETF-ova odobreno u SAD-u" },
    ],
    bottomLine: "Bitcoin je od nepoznatog dokumenta narastao u klasu imovine vrijednu 2+ bilijuna dolara u 15 godina. Nijedna imovina u povijesti nije rasla brže.",
  },
  {
    id: 11,
    type: "comparison",
    tag: "POGLAVLJE 11 — USPOREDBA",
    title: "Bitcoin Protiv\nSvega Ostalog",
    assets: [
      { name: "Bitcoin", supply: "Fiksna (21M)", censorship: "Nemoguća", seizure: "Nemoguće", portability: "Trenutno, globalno", verification: "Svatko može provjeriti", highlight: true },
      { name: "Zlato", supply: "~1.5% godišnji rast", censorship: "Moguća", seizure: "Lako (Izvršna naredba 6102)", portability: "Teško, sporo, skupo", verification: "Zahtijeva analizu", highlight: false },
      { name: "Fiat Valuta", supply: "Neograničena", censorship: "Rutinska", seizure: "Trivijalno (zamrzavanje računa)", portability: "Ograničena granicama", verification: "Vjeruj vladi", highlight: false },
    ],
    bottomLine: "Bitcoin je jedina imovina u ljudskoj povijesti koja kombinira apsolutnu oskudicu s savršenom prenosivošću i istinskim vlasništvom.",
  },
  {
    id: 12,
    type: "cryptointro",
    tag: "POGLAVLJE 12 — IZVAN BITCOINA",
    title: "Kripto\nRevolucija",
    subtitle: "Bitcoin Je Bio Samo Početak",
    body: "Bitcoin je dokazao da je decentralizirani novac bez povjerenja moguć. Ali tehnologija iza njega — blockchain — otključala je nešto mnogo veće: novi temelj za cijeli financijski sustav. I na kraju, za sam internet.",
    pillars: [
      { name: "Pametni Ugovori", description: "Samoizvršavajući sporazumi koji se pokreću kodom, ne odvjetnicima. Ako se X dogodi, Y automatski slijedi. Bez posrednika, bez kašnjenja, bez potrebe za povjerenjem.", icon: "code" },
      { name: "Decentralizirane Financije (DeFi)", description: "Bankarstvo bez banaka. Posuđivanje, zaduživanje, trgovanje i zarađivanje kamata — sve putem otvorenih protokola kojima svatko može pristupiti.", icon: "landmark" },
      { name: "Tokenizacija", description: "Svaka imovina — nekretnine, umjetnost, dionice, robe — može se prikazati kao digitalni token na blockchainu. Frakcijsko vlasništvo za sve.", icon: "coins" },
      { name: "Digitalno Vlasništvo", description: "Po prvi put možete istinski posjedovati digitalnu imovinu. Ne licencu, ne dozvolu — stvarno vlasništvo dokazano kriptografijom.", icon: "key" },
    ],
  },
  {
    id: 13,
    type: "defi",
    tag: "POGLAVLJE 13 — NOVI FINANCIJSKI SUSTAV",
    title: "DeFi Obnavlja\nFinancije Od\nTemelja",
    body: "Tradicionalni financijski sustav ima slojeve posrednika, od kojih svaki uzima dio i dodaje kašnjenje. DeFi ih sve uklanja. Što je trebalo dane sada traje sekunde. Što je koštalo tisuće sada košta cente. Što je zahtijevalo dozvolu sada zahtijeva samo internetsku vezu.",
    defiStats: [
      { value: "$180B+", label: "Ukupna vrijednost zaključana u DeFi protokolima" },
      { value: "24/7/365", label: "Tržišta se nikad ne zatvaraju. Bez praznika." },
      { value: "< $0.01", label: "Trošak transakcije na modernim L2 mrežama" },
      { value: "1.4 Mlrd", label: "Odraslih bez bankovnog računa koji sada mogu pristupiti financijama" },
    ],
    useCases: [
      { title: "Posuđivanje i Zaduživanje", description: "Zaradite kamatu na svoj kripto ili se zadužite uz njega — trenutno, bez provjere kreditne sposobnosti." },
      { title: "Decentralizirane Burze", description: "Trgujte bilo kojom imovinom, bilo kada, s bilo kojeg mjesta. Bez KYC-a, bez računa, bez dozvole." },
      { title: "Stabilni Novčići", description: "Tokeni vezani za dolar koji kombiniraju stabilnost fiata sa slobodom kripta. 150+ mlrd $ u opticaju." },
    ],
  },
  {
    id: 14,
    type: "future",
    tag: "POGLAVLJE 14 — ŠTO DOLAZI",
    title: "Budućnost\nNovca",
    body: "Nalazimo se u ranim poglavljima najtemeljitije transformacije novca od izuma bankarstva. Pitanje nije hoće li se to dogoditi — nego razumijete li to prije svih ostalih.",
    trends: [
      { title: "Bitcoin kao Digitalno Zlato", description: "Države dodaju Bitcoin u svoje rezerve. El Salvador, Butan i drugi već su počeli. SAD ima izvršnu naredbu o Strateškoj Bitcoin Rezervi.", status: "Događa Se Sada" },
      { title: "Tokenizacija Stvarne Imovine", description: "BlackRock, JP Morgan i Goldman Sachs tokeniziraju državne obveznice, nekretnine i privatni kapital. Tržište od 16 bil $ do 2030.", status: "Ubrzava Se" },
      { title: "AI + Kripto Konvergencija", description: "AI agenti koji donose autonomne financijske odluke, mikroplaćanja za računanje, decentralizirani AI trening — dvije najveće tehnologije naše ere se spajaju.", status: "U Nastajanju" },
      { title: "Financijska Inkluzija", description: "1,4 milijarde odraslih nema bankovni račun. Sa pametnim telefonom i kriptom mogu pristupiti cijelom globalnom financijskom sustavu. Bez dozvole.", status: "U Tijeku" },
    ],
  },
  {
    id: 15,
    type: "closing",
    tag: "ZAKLJUČAK",
    title: "Izbor Je\nNa Vama",
    body: "Trenutni financijski sustav dizajniran je za izvlačenje bogatstva od mnogih i koncentraciju u rukama nekolicine. Bitcoin i širi kripto ekosustav nude izlaz — ne kroz nasilje ili revoluciju, nego kroz matematiku, kod i dobrovoljno usvajanje.",
    finalQuote:
      '"Temeljni problem konvencionalnih valuta je svo povjerenje koje je potrebno da bi funkcionirale." — Satoshi Nakamoto',
    cta: "Počni Učiti o Bitcoinu",
    ctaLink: "https://bitcoin.org",
  },
];

export const siteConfig = {
  title: "Problem Novca",
  description: "Razumijevanje pokvarenog monetarnog sustava i kripto revolucije",
  totalSlides: 16,
};
